import { Controller } from "stimulus"

export default class extends Controller {
  open(event) {
    event.preventDefault();

    this.element.showModal();
  }

  close(event) {
    event.preventDefault();

    this.element.close();
  }
}
